"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCache = void 0;
var serialize = function (obj) {
    if (Array.isArray(obj)) {
        return JSON.stringify(obj.map(function (i) { return serialize(i); }));
    }
    else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj)
            .sort()
            .map(function (k) { return k + ":" + serialize(obj[k]); })
            .join('|');
    }
    return obj + '';
};
var createCache = function () {
    var cache = {};
    var set = function (key, value) {
        var cacheKey = serialize(key);
        cache[cacheKey] = value;
    };
    var getIfExist = function (key) {
        var cacheKey = serialize(key);
        return cache[cacheKey];
    };
    return {
        set: set,
        getIfExist: getIfExist,
        getOrElse: function (key, fn) {
            var value = getIfExist(key);
            if (value !== undefined) {
                return value;
            }
            var newValue = fn();
            set(key, newValue);
            return newValue;
        },
        clear: function () {
            Object.keys(cache)
                .forEach(function (key) {
                delete cache[key];
            });
        }
    };
};
exports.createCache = createCache;
